import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import moment from "moment";
import { ADDED_BY_ID } from "../../Constants"; // Assuming ADDED_BY_ID is imported from your constants file
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CustomFieldsForUser = ({
    customFields,
    fieldValues,
    setCustomeLocalImage,
    setFieldValues,
    setCustomFields,
    getUserCustomFieldData,
    userID,
    checkedData,
    setCheckedData,
    dataLoading
}) => {

    // const [checkedData, setCheckedData] = useState([]);

    // Update input fields
    const handleInputChange = (customeFieldID, value) => {
        // Update both customFields and fieldValues
        const updatedFields = customFields.map((item) => {
            if (item.CustomFieldsID === customeFieldID) {
                item.CustomField_Value = value;
                item.CustomField_IDFK = item.CustomFieldsID; // Set CustomField_IDFK
                item.AddedByID = ADDED_BY_ID; // Set AddedByID
            }
            return item;
        });
        setCustomFields(updatedFields);

        // Also update fieldValues
        setFieldValues((prevState) => ({
            ...prevState,
            [customeFieldID]: value,
        }));
    };

    // Handle date changes
    const handleDateChange = (id, date) => {
        const formattedDate = moment(date).format("YYYY-MM-DD");

        // Update fieldValues and customFields with the selected date
        setFieldValues((prevState) => ({
            ...prevState,
            [id]: formattedDate,
        }));

        const updatedFields = customFields.map((item) => {
            if (item.CustomFieldsID === id) {
                item.CustomField_Value = formattedDate;
                item.CustomField_IDFK = item.CustomFieldsID; // Set CustomField_IDFK
                item.AddedByID = ADDED_BY_ID; // Set AddedByID
            }
            return item;
        });
        setCustomFields(updatedFields);
    };

    // Handle dropdown selection change
    const handleSelectChange = (id, value) => {
        // Update both fieldValues and customFields
        setFieldValues((prevState) => ({
            ...prevState,
            [id]: value,
        }));

        const updatedFields = customFields.map((item) => {
            if (item.CustomFieldsID === id) {
                item.CustomField_Value = value;
                item.CustomField_IDFK = item.CustomFieldsID; // Set CustomField_IDFK
                item.AddedByID = ADDED_BY_ID; // Set AddedByID
            }
            return item;
        });
        setCustomFields(updatedFields);
        console.log(updatedFields, 'updatedFields')
    };

    // Handle checkbox changes
    const handleCheckboxChange = (customFieldID, value, e) => {
        let updatedCheckedData = [...checkedData];

        if (e.target.checked) {
            updatedCheckedData.push({ fieldId: customFieldID, value: value });
        } else {
            updatedCheckedData = updatedCheckedData.filter(
                (item) => !(item.fieldId === customFieldID && item.value === value)
            );
        }

        const selectedOptions = updatedCheckedData.filter(
            (item) => item.fieldId === customFieldID
        );

        const updatedValueString = selectedOptions.map((item) => item.value).join(',');

        // Update both checkedData and customFields
        setCheckedData(updatedCheckedData);
        const updatedFields = customFields.map((item) => {
            if (item.CustomFieldsID === customFieldID) {
                item.CustomField_Value = updatedValueString;
                item.CustomField_IDFK = item.CustomFieldsID; // Set CustomField_IDFK
                item.AddedByID = ADDED_BY_ID; // Set AddedByID
            }
            return item;
        });
        setCustomFields(updatedFields);

        // Also update fieldValues
        setFieldValues((prevState) => ({
            ...prevState,
            [customFieldID]: updatedValueString,
        }));
    };

    // useEffect(() => {
    //     if (userID && Array.isArray(customFields) && Array.isArray(getUserCustomFieldData)) {
    //         const mergedFields = customFields.map((field) => {
    //             const matchedValue = getUserCustomFieldData.find(
    //                 (val) => val.CustomFieldID === field.CustomFieldsID
    //             );

    //             return {
    //                 ...field,
    //                 CustomField_Value: matchedValue ? matchedValue.CustomFieldValue : field.CustomField_Value || "",
    //             };
    //         });

    //         setCustomFields(mergedFields);

    //         const initialFieldValues = {};
    //         mergedFields.forEach((f) => {
    //             initialFieldValues[f.CustomFieldsID] = f.CustomField_Value || "";
    //         });
    //         setFieldValues(initialFieldValues);
    //     }
    // }, [userID, getUserCustomFieldData]);


    useEffect(() => {
        if (!Array.isArray(customFields)) return;

        if (!userID) {
            // 🔹 Case 1: ADD → reset all
            const clearedFields = customFields.map((f) => ({
                ...f,
                CustomField_Value: "",
            }));

            setCustomFields(clearedFields);

            const resetValues = {};
            clearedFields.forEach((f) => {
                resetValues[f.CustomFieldsID] = "";
            });

            setFieldValues(resetValues);
            setCheckedData([]); // reset checkboxes
        } else if (Array.isArray(getUserCustomFieldData) && getUserCustomFieldData.length > 0) {
            // 🔹 Case 2: EDIT with data → merge
            const mergedFields = customFields.map((field) => {
                const matchedValue = getUserCustomFieldData.find(
                    (val) => val.CustomFieldID === field.CustomFieldsID
                );

                return {
                    ...field,
                    CustomField_Value: matchedValue
                        ? matchedValue.CustomFieldValue
                        : field.CustomField_Value || "",
                };
            });

            setCustomFields(mergedFields);

            const initialValues = {};
            const newCheckedData = []; // ✅ to rebuild checkbox selections

            mergedFields.forEach((f) => {
                initialValues[f.CustomFieldsID] = f.CustomField_Value || "";

                // ✅ If this field is a checkbox and has saved values, restore them
                if (f.FieldType?.toLowerCase() === "checkbox" && f.CustomField_Value) {
                    f.CustomField_Value.split(",").forEach((val) => {
                        newCheckedData.push({ fieldId: f.CustomFieldsID, value: val.trim() });
                    });
                }
            });

            setFieldValues(initialValues);
            setCheckedData(newCheckedData); // ✅ restore checkbox selections
        } else {
            // 🔹 Case 3: EDIT but no data
            const clearedFields = customFields.map((f) => ({
                ...f,
                CustomField_Value: "",
            }));

            setCustomFields(clearedFields);

            const resetValues = {};
            clearedFields.forEach((f) => {
                resetValues[f.CustomFieldsID] = "";
            });

            setFieldValues(resetValues);
            setCheckedData([]); // reset checkboxes
        }
    }, [userID, getUserCustomFieldData]); // 🚨 keep only these two deps

    // Render the appropriate field based on its type
    const renderField = (field) => {
        const fieldValue = fieldValues[field.CustomFieldsID] || field.CustomField_Value;

        switch (field.FieldType.toLowerCase()) {
            case "text":
            case "email":
            case "phone":
                return (
                    dataLoading ? (
                        <Skeleton height={38} />
                    ) : (
                        <Form.Control
                            key={field.CustomFieldsID}
                            type={field.FieldType.toLowerCase()}
                            maxLength={field.FieldType === "phone" && 10}
                            placeholder={field.PlaceHolder || "Enter value..."}
                            // value={field.value}
                            value={fieldValue}
                            onChange={(e) => handleInputChange(field.CustomFieldsID, e.target.value)}
                        />)
                );
            case "date":
                const dateValue = fieldValue ? new Date(fieldValue) : null;
                return (
                    dataLoading ? (
                        <Skeleton height={38} />
                    ) : (
                        <DatePicker
                            key={field.CustomFieldsID}
                            className="select from-date"
                            id="date-range-picker"
                            selected={dateValue}
                            value={fieldValue || ""}
                            dateFormat="dd/MM/yyyy"
                            placeholderText={field.PlaceHolder || "Select date"}
                            onChange={(date) => handleDateChange(field.CustomFieldsID, date)}
                        />)
                );
            case "textarea":
                return (
                    dataLoading ? (
                        <Skeleton height={38} />
                    ) : (
                        <Form.Control
                            key={field.CustomFieldsID}
                            as="textarea"
                            rows={3}
                            placeholder={field.PlaceHolder || "Enter text..."}
                            value={fieldValue || ""}
                            onChange={(e) => handleInputChange(field.CustomFieldsID, e.target.value)}
                        />)
                );
            case "radio":
                return field.FieldOptions.split(",").map((option, index) => (
                    <Form.Check
                        key={index}
                        type="radio"
                        label={option}
                        name={field.FieldName}
                        id={`${field.FieldName}-${index}`}
                        readOnly={field.ReadOnly}
                        checked={fieldValue === option}
                        onChange={() => handleInputChange(field.CustomFieldsID, option)}
                    />
                ));
            case "checkbox":
                return field.FieldOptions.split(",").map((option, index) => (
                    <Form.Check
                        key={index}
                        type="checkbox"
                        label={option}
                        id={`${field.FieldName}-${index}`}
                        readOnly={field.ReadOnly}
                        checked={fieldValue && fieldValue.includes(option)}
                        onChange={(e) => {
                            handleCheckboxChange(field.CustomFieldsID, option, e);
                        }}
                    />
                ));
            case "dropdown":
                return (
                    dataLoading ? (
                        <Skeleton height={38} />
                    ) : (
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            key={field.CustomFieldsID}
                            options={field.FieldOptions.split(",").map((option) => ({
                                value: option,
                                label: option,
                            }))}
                            placeholder={field.PlaceHolder || "Select option"}
                            isDisabled={field.ReadOnly}
                            value={fieldValue ? { value: fieldValue, label: fieldValue } : null}
                            onChange={(selectedOption) => handleSelectChange(field.CustomFieldsID, selectedOption.value)}
                            menuPosition="fixed"
                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                        />)
                );
            case "file":
                return (
                    <Form.Group key={field.CustomFieldsID}>
                        <div className="drop-area">
                            <img src="../../../images/DefaultImages/UploadImages.svg" alt="" />
                            <p>Drag and drop images here</p>
                            <p>OR</p>
                            <input
                                type="file"
                                onChange={(e) => handleInputChange(field.CustomFieldsID, e.target.files[0])}
                            />
                        </div>
                    </Form.Group>
                );
            case "button":
                return (
                    <Button
                        key={field.CustomFieldsID}
                        variant="primary"
                        type="submit"
                        disabled={field.ReadOnly}
                    >
                        {field.FieldName}
                    </Button>
                );
            default:
                return null;
        }
    };

    return (
        <Form>
            <Row>
                {Array.isArray(customFields) && customFields.map((field) => (
                    <Col md={4} key={field.CustomFieldsID}>
                        <Form.Group className="control-form-group mb-3">
                            <Form.Label className="control-form-label m-0 pt-2 pb-2">
                                {field.LabelName || "Untitled Field"}
                            </Form.Label>
                            <div className="fullname-form-control">
                                {renderField(field)}
                            </div>
                        </Form.Group>
                    </Col>
                ))}
            </Row>
        </Form>
    );
};

export default CustomFieldsForUser;
